import Lottie from 'lottie-react';
import animationData from '../../../../assets/lottie/kubit-loading.json';
import gradientAnimationData from '../../../../assets/lottie/kubit-loading-gradient.json';
import React, { PropsWithChildren, useMemo } from 'react';
import styled from 'styled-components';

interface IProps {
  height: number | string;
  isGradient?: boolean;
}

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const KubitLogoLoader = ({
  height,
  isGradient,
  children,
}: PropsWithChildren<IProps>) => {
  const { lottieAnimationData, lottieAnimationSize } = useMemo(() => {
    return isGradient
      ? {
          lottieAnimationData: gradientAnimationData,
          lottieAnimationSize: '32px',
        }
      : {
          lottieAnimationData: animationData,
          lottieAnimationSize: '75px',
        };
  }, [isGradient]);

  return (
    <Wrapper style={{ height }}>
      <Lottie
        animationData={lottieAnimationData}
        loop
        autoplay
        style={{ height: lottieAnimationSize, width: lottieAnimationSize }}
      />
      {children}
    </Wrapper>
  );
};

export default KubitLogoLoader;
